module.exports = __webpack_public_path__ + "img/grid-icon.c3421a62.svg";